import { Component, inject } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { ModuleLoaderComponent } from '../module-loader/module-loader.component';

@Component({
  selector: 'app-page-not-found',
  standalone: true,
  imports: [RouterModule, ModuleLoaderComponent],
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.scss'
})
export class PageNotFoundComponent {
  // fetching route data
  #route = inject(ActivatedRoute);
  pageType = toSignal(this.#route.data.pipe(map(data => data['type'])));
}
